import { render, staticRenderFns } from "./TreeViewer.vue?vue&type=template&id=08212651&scoped=true"
import script from "./TreeViewer.vue?vue&type=script&lang=js"
export * from "./TreeViewer.vue?vue&type=script&lang=js"
import style0 from "./TreeViewer.vue?vue&type=style&index=0&id=08212651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08212651",
  null
  
)

export default component.exports